import React, { useEffect, useState } from "react";
import { baseRequest } from "../../../axiosconfig";
import { useNavigate } from "react-router-dom";
import Loading from "../../loading";

function ArchiveFormulariRizika() {
  const [riskForms, setRiskForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const headerTitles = [
    { id: 1, title: "Šifra procesa", width: "10%" },
    { id: 2, title: "Poslovni proces", width: "20%" },
    { id: 3, title: "Vlasnik procesa", width: "15%" },
    { id: 4, title: "Ime rizika", width: "20%" },
    { id: 5, title: "Odobrio", width: "10%" },
    { id: 6, title: "Datum izmene", width: "12%" },
    { id: 7, title: "", width: "9%" },
  ];

  useEffect(() => {
    setLoading(true);
    baseRequest
      .get("/risk_forms")
      .then((res) => {
        if (res.data.risk_forms) {
          setRiskForms(
            res.data.risk_forms.filter((form) => form.is_archived && !form.del)
          );
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="table-scroll">
      <ul
        className="admin-formulari-rizika-list-header"
        style={{
          borderTop: "var(--mainBorder)",
          borderLeft: "var(--mainBorder)",
          borderRight: "var(--mainBorder)",
        }}
      >
        {headerTitles.map((item) => (
          <li
            key={item.id}
            className="admin-formulari-rizika-list-header-item"
            style={{ width: item.width }}
          >
            {item.title}
          </li>
        ))}
      </ul>
      {!loading && riskForms.length === 0 && (
        <p style={{ color: "var(--mainColor)", padding: "20px" }}>
          Nema arhiviranih formulara rizika.
        </p>
      )}
      <ul className="admin-formulari-rizika-list">
        {riskForms.map((form) => (
          <ul
            key={form.id}
            className="admin-formulari-list-item"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/admin/formulari-rizika/${form.id}`)}
          >
            <li
              className="admin-formulari-list-item-cell"
              style={{ width: "10%" }}
            >
              {form.business_process_list?.code}
            </li>
            <li
              className="admin-formulari-list-item-cell"
              style={{ width: "20%" }}
            >
              {form.business_process_list?.name}
            </li>
            <li
              className="admin-formulari-list-item-cell"
              style={{
                width: "15%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              {form.business_process_list?.business_process_owners?.map(
                (owner) => (
                  <div key={owner.id}>
                    <span>
                      {owner.first_name} {owner.last_name}
                    </span>
                  </div>
                )
              )}
            </li>
            <li
              className="admin-formulari-list-item-cell"
              style={{ width: "20%" }}
            >
              {form.name}
            </li>
            <li
              className="admin-formulari-list-item-cell"
              style={{ width: "10%" }}
            ></li>
            <li
              className="admin-formulari-list-item-cell"
              style={{ width: "12%" }}
            >
              {form.updated_at ? form.updated_at.split("T")[0] : ""}
            </li>
            <li style={{ flex: "1" }}>
              <button
                className="options-buttons-block-button"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/admin/formulari-rizika/${form.id}`);
                }}
              >
                <img alt="" src="/images/showpassword.png" />
              </button>
            </li>
          </ul>
        ))}
      </ul>
      <Loading isLoading={loading} />
    </div>
  );
}

export default ArchiveFormulariRizika;
